<template>
  <div>
    <fl-modal width="50%" ref="modalEditarTrecho">
      <template v-slot:header><fa-icon icon="pen-alt" /> Editar</template>
      <form @submit.prevent="validateBeforeSubmit">
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Acionamento (UTC):</label>
          <div class="col-sm-9">
            <input v-model="formTrecho.acionamentoUTC"
                class="form-control form-control-sm"
                v-validate="'required'"
                style="display:none"
                name="acionamentoUTC"
                :class="{'is-invalid' : errors.has('acionamentoUTC')}" />
            <date-picker ref="date"
                  :clearable="true"
                  :input-class="'form-control form-control-sm teste' + (errors.has('acionamentoUTC') ? 'is-invalid' : '' )"
                  v-model="formTrecho.acionamentoUTC"
                  format="DD/MM/YYYY HH:mm"
                  type="datetime"
                  :minute-step="1"
                  :confirm="true"
                  lang="pt-br"></date-picker>
            <span  class="invalid-feedback" v-show="errors.has('acionamentoUTC')">{{ errors.first('acionamentoUTC') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Decolagem (UTC):</label>
          <div class="col-sm-9">
            <input v-model="formTrecho.decolagemUTC"
              class="form-control form-control-sm"
              v-validate="'required'"
              style="display:none"
              name="formTrecho.decolagemUTC"
              :class="{'is-invalid' : errors.has('formTrecho.decolagemUTC')}" 
            />
            <date-picker ref="date"
              :clearable="true"
              :input-class="'form-control form-control-sm teste' + (errors.has('formTrecho.decolagemUTC') ? 'is-invalid' : '' )"
              v-model="formTrecho.decolagemUTC"
              format="DD/MM/YYYY HH:mm"
              type="datetime"
              :minute-step="1"
              :confirm="true"
              lang="pt-br"
            />
            <span  class="invalid-feedback" v-show="errors.has('formTrecho.decolagemUTC')">{{ errors.first('formTrecho.decolagemUTC') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Pouso (UTC):</label>
          <div class="col-sm-9">
            <input v-model="formTrecho.pousoUTC"
              class="form-control form-control-sm"
              v-validate="'required'"
              style="display:none"
              name="formTrecho.pousoUTC"
              :class="{'is-invalid' : errors.has('pousoUTC')}" 
            />
            <date-picker ref="date"
              :clearable="true"
              :input-class="'form-control form-control-sm teste' + (errors.has('formTrecho.pousoUTC') ? 'is-invalid' : '' )"
              v-model="formTrecho.pousoUTC"
              format="DD/MM/YYYY HH:mm"
              type="datetime"
              :minute-step="1"
              :confirm="true"
              lang="pt-br"
            />
            <span  class="invalid-feedback" v-show="errors.has('formTrecho.pousoUTC')">{{ errors.first('formTrecho.pousoUTC') }}</span>
          </div>
        </div>
        <div class="form-group row">
          <label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Corte (UTC):</label>
          <div class="col-sm-9">
            <input v-model="formTrecho.corteUTC"
              class="form-control form-control-sm"
              v-validate="'required'"
              style="display:none"
              name="corteUTC"
              :class="{'is-invalid' : errors.has('corteUTC')}" 
            />
            <date-picker ref="date"
              :clearable="true"
              :input-class="'form-control form-control-sm teste' + (errors.has('formTrecho.corteUTC') ? 'is-invalid' : '' )"
              v-model="formTrecho.corteUTC"
              v-validate="'required'"
              format="DD/MM/YYYY HH:mm"
              type="datetime"
              :minute-step="1"
              :confirm="true"
              lang="pt-br"
            />
            <span  class="invalid-feedback" v-show="errors.has('corteUTC')">{{ errors.first('corteUTC') }}</span>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col-sm-12 text-right">
            <small class="float-left text-info">
              <fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.
            </small>
            <button class="btn btn-success btn-sm" @click.prevent="validateBeforeSubmit">
              <fa-icon icon="check" transform="left-3" /> EDITAR
            </button>
          </div>
        </div>
      </form>
    </fl-modal>
  </div>
</template>
<script>
import moment from 'moment'
import axios from '../../../../routers/axios';
import flModal from '../../../../components/modal/main.vue'
export default {
  components: {
		flModal
	},
  data() {
    return {
      formTrecho: {},
      acionamentoUTC: ''
    }
  },
  methods: {
    carregar(trecho){
      this.formTrecho = trecho
      this.$refs.modalEditarTrecho.show()
    },
    clickEditar(){
      let data = {
        aberto: this.formTrecho.aberto,
        id_flight: this.formTrecho.id_flight,
				imei: this.formTrecho.imei,
				acionamentoUTC:  new moment(this.formTrecho.acionamentoUTC).format("YYYY-MM-DD HH:mm"),
				decolagemUTC: new moment(this.formTrecho.decolagemUTC).format("YYYY-MM-DD HH:mm"),
				pousoUTC: new moment(this.formTrecho.pousoUTC).format("YYYY-MM-DD HH:mm"),
				corteUTC: new moment(this.formTrecho.corteUTC).format("YYYY-MM-DD HH:mm"),
			}
      axios.put(this._getUrl(`api/equipamentotrecho/${this.formTrecho.id}`), data).then(response => {
        this.$emit("editou-trecho", response.data)
        this.$notify.show('success', 'Trecho atualizado.')
        this.$refs.modalEditarTrecho.hide();
      });
    },
    
    validateBeforeSubmit() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.clickEditar();
				}
			});
		},
  }
}
</script>


// WEBPACK FOOTER //
// src/views/equipamento/detalhe/trecho/editarTrecho.vue